<template>
<v-card class="p-3">
  <h5>Sélections Apidae</h5>
  <v-skeleton-loader v-if="loading" type="list-item@2" class="mt-2"></v-skeleton-loader>
  <v-simple-table fixed-header v-else-if="selections.length">
    <tbody>
    <tr v-for="selection in selections" :key="selection.id">
      <td>
          {{ selection.name }}
      </td>
      <td>
        <div>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon target="_blank" :href="'https://base.apidae-tourisme.com/diffuser/selection/' + selection.external_id + '?5&spid=4#tab-contenu'">
                <v-icon>open_in_new</v-icon>
              </v-btn>
            </template>
            <span>Voir la sélection sur Apidae</span>
          </v-tooltip>
        </div>
      </td>
    </tr>
    </tbody>
  </v-simple-table>
  <div class="text-center" v-else>
    <small>
      Aucune sélection
    </small>
  </div>
</v-card>
</template>

<script>
export default {
  name: "SelectionBloc",
  props: ['providerId'],
  data() {
    return {
      selections: [],
      loading: true,
    }
  },
  methods: {
    getSelections() {
      this.loading = true
      this.$http.get('auth/providers/' + this.providerId + '/selections').then(res => {
        this.selections = res.body.data.selections
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  },
  created() {
    this.getSelections()
  }
}
</script>

